import React, { useEffect } from "react";
import * as styles from "./PageWrapper.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import Button from "@app/components/Button";
// import { useDispatch } from "react-redux";

const PageWrapper = ({
	className,
	buttons,
	isForm = false,
	vCenter = false,
	vBetween = false,
	noStyling = false,
	initialValues,
	onSubmit,
	children,
}) => {
	// const dispatch = useDispatch();
	const pageWrapperClassName = classNames({
		[styles["page-wrapper"]]: true,
		[styles["page-wrapper--no-styling"]]: noStyling,
		[className]: !!className,
	});

	const contentClassName = classNames({
		[styles["content"]]: true,
		["justify-content-center"]: vCenter,
		["justify-content-between"]: vBetween,
	});

	return (
		<div className={pageWrapperClassName}>
			{isForm ? (
				<Formik
					initialValues={initialValues || {}}
					onSubmit={(values) => {
						onSubmit();
					}}
					enableReinitialize={true}
				>
					{(formikProps) => {
						useEffect(() => {
							// if (formikProps.dirty) {
							// 	dispatch(enableSaveAction());
							// } else {
							// 	dispatch(disableSaveAction());
							// }
						}, [formikProps.values, formikProps.isSubmitting]);

						return (
							<Form onSubmit={formikProps.handleSubmit} noValidate={true}>
								{typeof children === "function" ? (
									children(formikProps)
								) : (
									<div className={classNames(styles["content-wrapper"], "content-wrapper")}>
										<div className={styles["content"]}>{children}</div>
										{buttons && (
											<div className={styles["buttons-container"]}>
												{buttons?.map(({ label, type, onClick, isSubmit }, index) => (
													<Button
														key={index}
														label={label}
														type={type}
														isSubmit={isSubmit}
														callback={onClick}
													/>
												))}
											</div>
										)}
									</div>
								)}
								<input type={"submit"} className={"js-submit"} />
							</Form>
						);
					}}
				</Formik>
			) : (
				<div className={styles["content-wrapper"]}>
					<div className={contentClassName}>{children}</div>
					{buttons && (
						<div className={styles["buttons-container"]}>
							{buttons?.map(({ label, type, onClick, isSubmit }, index) => (
								<Button key={index} label={label} type={type} isSubmit={isSubmit} callback={onClick} />
							))}
						</div>
					)}
				</div>
			)}
		</div>
	);
};

PageWrapper.propTypes = {
	className: PropTypes.string,
	isForm: PropTypes.bool,
	// buttons: PropTypes.node,
	buttons: PropTypes.arrayOf(
		PropTypes.shape({
			type: PropTypes.string,
			label: PropTypes.string.isRequired,
			onClick: PropTypes.func.isRequired,
			isSubmit: PropTypes.bool,
		}),
	),
	vCenter: PropTypes.bool,
	vBetween: PropTypes.bool,
	noStyling: PropTypes.bool,
	initialValues: PropTypes.object,
	onSubmit: PropTypes.func,
	children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

export default PageWrapper;
